export const genders = [
  { id: 1, name: "Male" },
  { id: 2, name: "Female" },
];
